import Modal from 'react-modal';
import { GlobalStyled } from './styles/globals'
import { Dashboard } from './components/Dashboard';
import { TransactionsProvider } from './hooks/useTransactions';

Modal.setAppElement('#root');

export function App() {
  return (
    <TransactionsProvider>
      {/* <Header onOpenNewTransactionModal={handleOpenNewTransactionModal} /> */}
      <Dashboard />
      <GlobalStyled />
    </TransactionsProvider>
  );
}

